<form [formGroup]="childForm">
  <mat-accordion #accordion="matAccordion">
    <mat-expansion-panel
      (opened)="settingsPanelOpenState = true"
      (closed)="settingsPanelOpenState = false"
      [disabled]="!canAddModifiers"
      [expanded]="open"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Chart Settings </mat-panel-title>
        <mat-panel-description *ngIf="settingsPanelOpenState">
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <ng-container>
          <app-grouping
            [currentDataFields]="currentDataFields"
            [groupFields]="groupFields"
            [canvasOptions]="canvasOptions"
            [chartType]="chartType"
          ></app-grouping>
          <app-quantifiers
            [currentDataFields]="currentDataFields"
            [calculationOptions]="calculationOptions"
            [chartType]="chartType"
          ></app-quantifiers>
          <app-data-visibility
            [currentDataFields]="currentDataFields"
            [visibleDataPoints]="visibleDataPoints"
            [chartType]="chartType"
            [chartData]="chartData"
            *ngIf="chartType == 'Table' || chartType == 'List'"
          ></app-data-visibility>
          <app-series
            [currentDataFields]="currentDataFields"
            [appliedSeries]="appliedSeries"
            [chartType]="chartType"
            [chartData]="chartData"
            *ngIf="chartType != 'Table' && chartType != 'List'"
          ></app-series>
        </ng-container>
        <ng-container
          *ngIf="!currentDataFields || currentDataFields.length <= 0"
        >
          <div class="notAvailable">
            Data for this chart needs to be chosen before modifying chart
            settings.
          </div>
        </ng-container>
      </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel
      (opened)="sortPanelOpenState = true"
      (closed)="sortPanelOpenState = false"
      [disabled]="!canAddModifiers"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Sorts
          <span class="circle" *ngIf="sortFields && sortFields.length > 0"
            >( {{ sortFields.length }} )</span
          ></mat-panel-title
        >
        <mat-panel-description *ngIf="sortPanelOpenState">
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent
        ><app-sorting
          [currentDataFields]="currentDataFields"
          [sortFields]="sortFields"
          [canvasOptions]="canvasOptions"
        ></app-sorting>

        <app-limit
          [currentDataFields]="currentDataFields"
          [chartType]="chartType"
        ></app-limit>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="filterPanelOpenState = true"
      (closed)="filterPanelOpenState = false"
      [disabled]="!canAddModifiers"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          Filters
          <span
            class="circle"
            *ngIf="
              currentFilterFields &&
              currentFilterFields.length +
                departmentScopeLength +
                employeeScopeLength >
                0
            "
            >(
            {{
              currentFilterFields.length +
                departmentScopeLength +
                employeeScopeLength
            }}
            )</span
          ></mat-panel-title
        >
        <mat-panel-description *ngIf="filterPanelOpenState">
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent
        ><app-filters
          [currentFilterFields]="currentFilterFields"
          [currentDataFields]="currentDataFields"
          [departmentScope]="departmentScope"
          [employeeScope]="employeeScope"
        ></app-filters
      ></ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel
      (opened)="formatPanelOpenState = true"
      (closed)="formatPanelOpenState = false"
      [disabled]="!canAddModifiers"
    >
      <mat-expansion-panel-header>
        <mat-panel-title> Format </mat-panel-title>
        <mat-panel-description *ngIf="formatPanelOpenState">
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent
        ><app-formating
          [chartType]="chartType"
          [formatdata]="formatdata"
          [isComponentOpen]="formatPanelOpenState"
          [chartData]="chartData"
        ></app-formating
      ></ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel
      (opened)="coloringPanelOpenState = true"
      (closed)="coloringPanelOpenState = false"
      [disabled]="!canAddModifiers"
    >
      <mat-expansion-panel-header>
        <mat-panel-title> Colors </mat-panel-title>
        <mat-panel-description *ngIf="coloringPanelOpenState">
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent
        ><app-coloring
          [chartType]="chartType"
          [manualChartColors]="manualChartColors"
          [isComponentOpen]="coloringPanelOpenState"
          [currentDataFields]="currentDataFields"
          [visibleDataPoints]="visibleDataPoints"
          [appliedSeries]="appliedSeries"
        ></app-coloring
      ></ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="linkingPanelOpenState = true"
      (closed)="linkingPanelOpenState = false"
      [disabled]="!canAddModifiers"
    >
      <mat-expansion-panel-header>
        <mat-panel-title> Page Links </mat-panel-title>
        <mat-panel-description *ngIf="linkingPanelOpenState">
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <app-linking-component
          [chartType]="chartType"
          [drilldowndata]="formatdata"
          [currentDataFields]="currentDataFields"
          [workflows]="workflows"
        ></app-linking-component>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</form>
